import { render, staticRenderFns } from "./DefaultImage.vue?vue&type=template&id=21aad362&scoped=true"
import script from "./DefaultImage.vue?vue&type=script&lang=js"
export * from "./DefaultImage.vue?vue&type=script&lang=js"
import style0 from "./DefaultImage.vue?vue&type=style&index=0&id=21aad362&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aad362",
  null
  
)

export default component.exports